import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_GraphLegend = _resolveComponent("GraphLegend")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_v_skeleton_loader, {
            type: "image",
            height: "100%",
            width: "100%"
          }, null, 512), [
            [_vShow, !_ctx.loaded]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_layout, {
              row: "",
              class: "px-4 pb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "xs9" }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("div", { id: "productionGraphLegend" }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "xs3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      size: "x-small",
                      variant: "text",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.resetZoom()), ["stop"])),
                      id: "graphResetButton"
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("Reset Zoom", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "x-small",
                      variant: "text",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changeScale()), ["stop"])),
                      id: "graphResetButton"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.logscale ? "Log" : "Linear") + " Scale", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _cache[4] || (_cache[4] = _createElementVNode("div", { id: "productionGraph" }, null, -1)),
            _createVNode(_component_GraphLegend, {
              labels: _ctx.labels,
              colors: _ctx.colors
            }, null, 8, ["labels", "colors"])
          ], 512), [
            [_vShow, _ctx.loaded]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}